<header id="header">
  <div class="d-flex align-items-center justify-content-center px-2 h-100">
    <div class="logo mx-auto">
      <app-logo></app-logo>
    </div>
  </div>
</header>


